export default __webpack_public_path__ + "static/media/25t.eb1e8a0c.jpg";